export const STAGE_TYPES = {
  finish: 'finish',
  process: 'process',
  start: 'start'
}

export const QUIZ_FINISH_HEADS = {
  1: 'Ты приложил недостаточно усилий!',
  2: 'Будь внимательнее и не падай духом, у тебя все получится!',
  3: 'Вау! Да ты настоящий урбанист!'
}
